import { render, staticRenderFns } from "./corder-refound-status.vue?vue&type=template&id=271cb6f2&scoped=true&"
import script from "./corder-refound-status.vue?vue&type=script&lang=js&"
export * from "./corder-refound-status.vue?vue&type=script&lang=js&"
import style0 from "./corder-refound-status.vue?vue&type=style&index=0&id=271cb6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271cb6f2",
  null
  
)

export default component.exports